import { API, Endpoints } from '@brg/api';
import { useEffect, useState } from "react";
import useLocalization from "../useLocalization";
export var useGetLessonsCount = function (projectId) {
    var _a = useState(undefined), resp = _a[0], setResp = _a[1];
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    var language = useLocalization().language;
    useEffect(function () {
        if (!projectId)
            return;
        setIsLoading(true);
        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetLessonsCount')
            .get()
            .addQuery('projectId', projectId || '')
            .send()
            .then(function (r) { return r ? r.json() : undefined; })
            .then(function (r) {
            setIsLoading(false);
            setResp(((r === null || r === void 0 ? void 0 : r.status) === 400 || (r === null || r === void 0 ? void 0 : r.status) === 500) ? 0 : r);
        })
            .catch(function (e) {
            setIsLoading(false);
            setError(true);
        });
    }, [projectId]);
    return [API.toLang(resp, language), isLoading, error];
};
//# sourceMappingURL=useGetLessonsCount.js.mapimport { API, Endpoints } from '@brg/api';
import { useEffect, useState } from "react";
import useLocalization from "../useLocalization";
export var useGetLessonsCount = function (projectId) {
    var _a = useState(undefined), resp = _a[0], setResp = _a[1];
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    var language = useLocalization().language;
    useEffect(function () {
        if (!projectId)
            return;
        setIsLoading(true);
        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetLessonsCount')
            .get()
            .addQuery('projectId', projectId || '')
            .send()
            .then(function (r) { return r ? r.json() : undefined; })
            .then(function (r) {
            setIsLoading(false);
            setResp(((r === null || r === void 0 ? void 0 : r.status) === 400 || (r === null || r === void 0 ? void 0 : r.status) === 500) ? 0 : r);
        })
            .catch(function (e) {
            setIsLoading(false);
            setError(true);
        });
    }, [projectId]);
    return [API.toLang(resp, language), isLoading, error];
};
//# sourceMappingURL=useGetLessonsCount.js.map